"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _queryString = _interopRequireDefault(require("query-string"));

var _omit = _interopRequireDefault(require("lodash/omit"));

var _resize = require("../../hoc/resize.constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var helpers = {
  sizeRatioMap: _resize.sizeRatioMap,
  rawSrc: function rawSrc(src) {
    var index = src.indexOf('?');
    return src.substring(0, index === -1 ? src.length : index);
  },
  readSrcParams: function readSrcParams(src) {
    var blacklist = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['w', 'h'];

    var params = _queryString["default"].parse(src.replace(helpers.rawSrc(src), ''));

    return (0, _omit["default"])(params, blacklist);
  },
  ratio: function ratio(size) {
    var sizeDetails = _resize.sizeRatioDetails[size];
    return "".concat(sizeDetails.width, ":").concat(sizeDetails.height);
  }
};
var _default = helpers;
exports["default"] = _default;